import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import { Grid } from '@material-ui/core'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import LinearProgress from '@material-ui/core/LinearProgress'
import { makeStyles } from '@material-ui/core/styles'

import { hideReduxModal } from '../../../../Reducers/UI/actions'
import { number as numberValidation } from '../../../../Utils/Validators/formValidation'
import Form, { DateTimePicker } from '../../../Form'
import { Input } from '../../../Form/Input'

import SubmitButton from '../../../Form/SubmitButton'
import FormButton from '../../../Form/Button'
import { SectionLabel } from '../../../../Components/Section'
import { updateMission as updateMissionGQL } from '../../../../Module/graphQL'
import { getEditableFields } from '../../../../Containers/Form/Mission/EditMissionDetails/util'
import WeekSelect from '../../../Form/SelectDashboard/types/WeekSelect/WeekSelect'
import {
  formatToLocalDate,
  getEndOfWeek,
} from '../../../../shared/libraries/utils/date'

const useStyles = makeStyles(theme => ({
  list: {
    maxHeight: '40vh',
    overflow: 'scroll',
  },
}))

function BulkEditMissionModalBody({
  missionsToEdit,
  onClose = () => {},
  currencySign = '$',
}) {
  const [submitButtonDisabled, setSubmitButtonDisabled] = useState(false)
  const [log, setLog] = useState([])
  const [loadingProgress, setLoadingProgress] = React.useState(0)
  const [activeDateInput, setActiveDateInput] = useState(false)

  const dispatch = useDispatch()
  const classes = useStyles()

  const bulkEditHandler = async form => {
    const progressSection = 100 / missionsToEdit.length
    setLoadingProgress(1)
    const convertedFormData = Object.entries(form).reduce(
      (acc, [fieldName, { value }]) => {
        acc[fieldName] = value
        return acc
      },
      {},
    )
    for (const [index, mission] of missionsToEdit.entries()) {
      const humanReadableIndex = index + 1

      const editableFields = getEditableFields(
        mission.status,
        mission.type,
      ).filter(field =>
        ['dateTime', 'week', 'draftPayAdjustment', 'label'].includes(field),
      )
      editableFields.push('week')
      saveLogs(
        `#️⃣ ${humanReadableIndex}`,
        `💾 Saving mission with id: "${mission.id}"`,
        `📢 Editable fields for mission with status "${
          mission.status
        }" are: ${editableFields.join(', ')}`,
      )

      const missionDataInput = {
        missionInput: {
          id: mission.id,
          dateTime:
            editableFields.includes('dateTime') && convertedFormData.dateTime
              ? convertedFormData.dateTime
              : editableFields.includes('week') && convertedFormData.week
              ? formatToLocalDate(
                  getEndOfWeek(new Date(convertedFormData.week)),
                )
              : undefined,
          draftPayAdjustment:
            editableFields.includes('draftPayAdjustment') &&
            convertedFormData.draftPayAdjustment &&
            convertedFormData.draftPayAdjustment.length
              ? Number(convertedFormData.draftPayAdjustment)
              : undefined,
          label:
            convertedFormData.label && convertedFormData.label.length
              ? `${convertedFormData.label}#${humanReadableIndex}`
              : undefined,
        },
      }

      const options = { ignoreErrors: true }

      const response = await updateMissionGQL(missionDataInput, options)

      const result = await response.json()

      setLoadingProgress(progressSection * humanReadableIndex)

      if (result.errors && result.errors.length) {
        saveLogs(
          `❌ Mission was not updated. Reason: ${result.errors[0].message}`,
        )
      } else {
        saveLogs(`✅ Mission updated succesfully`)
      }
    }
    setLoadingProgress(100)
  }

  const saveLogs = (...logs) => setLog(currentLog => [...currentLog, ...logs])

  const onCloseHandler = () => {
    dispatch(hideReduxModal())
    onClose()
  }

  return !loadingProgress ? (
    <Form
      onUpdate={form => {
        if (form.name == 'week' && form.value) setActiveDateInput(form.name)
        if (form.name == 'dateTime' && form.value) setActiveDateInput(form.name)
        setSubmitButtonDisabled(form.isValid)
      }}
      onSubmit={bulkEditHandler}
    >
      <Grid container spacing={5}>
        <Grid item xs={12}>
          <SectionLabel>Date</SectionLabel>
          <DateTimePicker
            name="dateTime"
            initValue={new Date()}
            disabled={activeDateInput == 'week'}
          />
        </Grid>
        <Grid item xs={12}>
          <SectionLabel>Week</SectionLabel>
          <WeekSelect
            name="week"
            disabled={activeDateInput == 'dateTime'}
            label={
              'BA will be able to select a date for his mission inside this week'
            }
          />
        </Grid>

        <Grid item xs={12}>
          <SectionLabel>Pay аdjustment ({currencySign})</SectionLabel>
          <Input
            style={{ width: '100%' }}
            name="draftPayAdjustment"
            validator={[numberValidation]}
            initValue={0}
          />
        </Grid>
        <Grid item xs={12}>
          <SectionLabel>Label</SectionLabel>
          <Input style={{ width: '100%' }} name="label" initValue={''} />
        </Grid>
        <Grid item xs={12}>
          <Box pb={5} display="flex" justifyContent="space-between">
            <FormButton
              value="Cancel"
              onClick={() => dispatch(hideReduxModal())}
            />
            <SubmitButton disabled={!submitButtonDisabled} value="Save" />
          </Box>
        </Grid>
      </Grid>
    </Form>
  ) : (
    <div style={{ padding: 12 }}>
      <Grid container>
        <Grid item xs={12}>
          <LinearProgress variant="determinate" value={loadingProgress} />
          <Typography variant="h6">Log:</Typography>
          <List component="ul" className={classes.list}>
            {log.map(row => (
              <ListItem>
                <ListItemText primary={row} />
              </ListItem>
            ))}
          </List>
        </Grid>
        {loadingProgress === 100 && (
          <Grid item xs={12}>
            <Box display="flex" justifyContent="space-between">
              <FormButton value="Close" onClick={onCloseHandler} />
            </Box>
          </Grid>
        )}
      </Grid>
    </div>
  )
}

export default BulkEditMissionModalBody



// WEBPACK FOOTER //
// ./src/Components/BulkActions/blocks/BulkEditMissionModalBody/index.js